import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
//新增的
import Qrcode from "../views/Qrcode.vue";
//新增的
import ProductDetail from "../views/ProductDetail.vue";

import News from "../views/News.vue";
import New from "../views/New.vue";
//新增的
import Card from "../views/Card.vue";
import Certs from "../views/Certs.vue";

import Login from "../views/Login.vue";
import LoginIndex from "../views/Login/Index.vue";
import LoginCode from "../views/Login/Code.vue";
import LoginRegis from "../views/Login/Regis.vue";
import LoginResetpwd from "../views/Login/Resetpwd.vue";

import User from "../views/User.vue";
import UserInfo from "../views/User/Info.vue";
import ProductList from "../views/User/ProductList.vue";
import ProductSave from "../views/User/Product/ProductSave.vue";
import Change from "../views/User/Product/Change.vue";
import Success from "../views/User/Product/Success.vue";

import detail from "../views/User/detail.vue";
import accountsafety from "../views/User/accountsafety.vue";
import password from "../views/User/password.vue";

import Message from "../views/User/Message.vue";

// 生产厂商信息列表
import InfoList from "../views/User/InfoList.vue";

// 代理商信息
//修改的
import AgentInfo from "../views/User/AgentInfo.vue";
import AgentInfoShow from "../views/User/AgentInfoShow.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/", // 首页
    name: "Home",
    component: Home
  },
  {
    path: "/news", // 新闻列表页面
    name: "News",
    component: News
  },
  {
    path: "/new", // 首页
    name: "new",
    component: New
  },
  {
    path: "/card", //证书
    name: "Card",
    component: Card
  },
  {
    path: "/certs", //证书
    name: "Certs",
    component: Certs
  },
  {
    path: "/qrcode", // 二维码扫描显示详情
    name: "qrcode",
    component: ProductDetail
  },
  {
    path: "/productDetail", // 产品详情手机端
    name: "ProductDetail",
    component: Qrcode
  },
  {
    path: "/user", // 用户信息模板页
    name: "User",
    component: User,
    children: [
      {
        path: "productList", // 产品列表
        name: "ProductList",
        component: ProductList,
        meta: {
          name: "chanping"
        }
      },
      {
        path: "productSave", // 产品的信息页和产品的修改页面
        name: "ProductSave",
        component: ProductSave,
        meta: {
          name: "chanping"
        }
      },
      {
        path: "change", // 产品信息审核通过以后后面的流程，产品反复修改的页面
        name: "Change",
        component: Change,
        meta: {
          name: "chanping"
        }
      },
      {
        path: "productSuccess", // 成功提交信息
        name: "Success",
        component: Success
      },
      {
        path: "info", // 用户信息页面
        name: "UserInfo",
        component: InfoList,
        meta: {
          name: "info"
        }
      },

      {
        path: "detail", // 查看企业信息
        name: "detail",
        component: detail,
        meta: {
          name: "info"
        }
      },
      {
        path: "accountsafety", // 账户安全
        name: "Accountsafety",
        component: accountsafety,
        meta: {
          name: "anquan"
        }
      },
      {
        path: "password", // 修改密码
        name: "password",
        component: password
      },
      {
        path: "message", // 修改密码
        name: "Message",
        component: Message,
        meta: {
          name: "message"
        }
      },
      {
        path: "agentInfo", // 代理商信息页面
        name: "AgentInfo",
        component: AgentInfo,
        meta: {
          name: "info"
        }
      },
      {
        path: "agentInfoShow", // 生产商信息页面显示页面，这个页面的功能仅仅是从产品信息登记列表页跳转过来显示详情的不具备修改功能
        name: "AgentInfoShow",
        component: AgentInfoShow,
        meta: {
          name: "agentInfoShow"
        }
      },
      {
        path: "infoList", // 生产厂商信息列表页
        name: "InfoList",
        component: InfoList,
        meta: {
          name: "info"
        }
      },
      // 产品信息修改页面
      {
        path: "productInfoSave", // 生产厂商信息列表页
        name: "ProductInfoSave",
        component: UserInfo,
        meta: {
          name: "ProductList"
        }
      }
    ]
  },
  {
    path: "/login", // 登录首页
    name: "Login",
    component: Login,
    children: [
      {
        path: "", // 登录首页
        name: "LoginIndex",
        component: LoginIndex
      },
      {
        path: "/login/code", // 验证码登录页
        name: "LoginCode",
        component: LoginCode
      },
      {
        path: "/login/regis", // 注册页面
        name: "LoginRegis",
        component: LoginRegis
      },
      {
        path: "/login/resetpwd", // 找回密码页
        name: "LoginResetpwd",
        component: LoginResetpwd
      }
    ]
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
